import { Button, Snackbar } from "@mui/material";
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Fragment, useState } from "react";


const CopyExcelDataButtonTOB = ({ elementId, style, onClickStart=async() => {}, onClickEnd=async() => {} }) => {

  const [showSnackbar, setShowSnackbar] = useState(false);

  return (
    <Fragment>
      <Button
        size='small'
        variant="outlined"
        style={style}
        onClick={async () => {
          await onClickStart();

          var node = document.getElementById(elementId);

          node = node.cloneNode(true);

          // remove the first row and first columns
          const firstRow = node.getElementsByTagName("tr")[0];
          if (firstRow) {
            firstRow.parentNode.removeChild(firstRow);
          }

        
          // remove the first columns
          const rows = node.getElementsByTagName("tr");
          for (let i = 0; i < rows.length; i++) {
            const cells = rows[i].getElementsByTagName("td");
            if (cells.length > 0) {
              cells[0].parentNode.removeChild(cells[0]);
            }
          }


          const blob = new Blob([node.outerHTML], { type: "text/html" });
          const clipboardItem = new ClipboardItem({ "text/html": blob });

          await navigator.clipboard.write([clipboardItem]);

          setShowSnackbar(true);

          await onClickEnd();
        }}
        endIcon={<ContentCopyIcon />}
      >
        Copy Excel Data
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={showSnackbar}
        autoHideDuration={2500}
        onClose={() => setShowSnackbar(false)}
        message="Excel Data Copied to Clipboard. You can paste it into Excel, Google Sheets, or Outlook."
      />
    </Fragment>
  );
};

export default CopyExcelDataButtonTOB;